import React from 'react';
import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { ProductInventory } from '@domain/inventory/models/Inventory';
import { ProductSales } from '@domain/sales/models/Sales';
import { APP_CONFIG } from '../../../../config/app.config';
import DashboardStatusChip from '../general/DashboardStatusChip';
import {
  ForecastPeriodRange,
  formatQty,
  forecastChangePctInRange,
  getStockLevel,
  stockTone,
  STOCK_LEVEL_LABEL,
  sumActualSalesInRange,
  sumCompleteForecastInRange,
  sumForecastInRange,
} from './utils';

interface ProductTableRowProps {
  item: ProductInventory;
  periodRange: ForecastPeriodRange;
  today: Date;
  productSales?: ProductSales;
  onOpen: (item: ProductInventory) => void;
}

const ProductTableRow: React.FC<ProductTableRowProps> = ({
  item,
  periodRange,
  today,
  productSales,
  onOpen,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;
  const level = getStockLevel(item);
  const actual = periodRange.showActuals
    ? sumActualSalesInRange(
      productSales,
      periodRange.start,
      periodRange.end,
      today
    )
    : null;
  const forecast = periodRange.combineActualWithForecast
    ? sumCompleteForecastInRange(
      item,
      productSales,
      periodRange.start,
      periodRange.end,
      today
    )
    : sumForecastInRange(item, periodRange.start, periodRange.end);
  const change = forecastChangePctInRange(
    item,
    periodRange.start,
    periodRange.end
  );

  return (
    <TableRow
      hover
      onClick={() => onOpen(item)}
      sx={{
        cursor: 'pointer',
        '& td': {
          borderBottom: `1px solid ${colors.border}`,
          py: 2,
          px: 2,
        },
      }}
    >
      <TableCell>
        <Stack direction="row" alignItems="center" gap={2}>
          <Box
            component="img"
            src={item.product.image || ''}
            alt=""
            sx={{
              width: 40,
              height: 40,
              borderRadius: '4px',
              border: `1px solid ${colors.border}`,
              objectFit: 'contain',
              bgcolor: colors.background,
              flexShrink: 0,
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.visibility = 'hidden';
            }}
          />
          <Typography
            variant="body2"
            color={colors.primaryText}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {item.product.title || item.product.ean || 'Untitled product'}
          </Typography>
        </Stack>
      </TableCell>
{/* 
      <TableCell align="right">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          gap={1}
        >
          {actual != null && (
            <>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: '16px',
                  letterSpacing: '0.5px',
                  color: colors.primaryText,
                }}
              >
                {formatQty(actual)}
              </Typography>
              <Typography
                variant="body2"
                color={colors.secondaryText}
              >
                /
              </Typography>
            </>
          )}
          <Typography
            variant="body2"
            color={actual != null ? colors.primary : colors.primaryText}
          >
            {formatQty(forecast)}
          </Typography>

        </Stack>
      </TableCell> */}

      <TableCell align="left">
        <Typography variant="body2" >
          {item.quantity}
        </Typography>

      </TableCell>

      <TableCell align="right">

        <DashboardStatusChip
          label={STOCK_LEVEL_LABEL[level]}
          tone={stockTone(level)}
        />
      </TableCell>
    </TableRow>
  );
};

export default ProductTableRow;
